
<div class="second-level">
  <a
    [routerLink]="[categoryRoute, childCategory?.slug]"
    [queryParams]="queryParametersBuilder(childCategory?.id, parentCategory?.id)"
    (click)="onNestedCategoryClick(childCategory?.name, childCategory?.id, '', parentCategory?.name)"
    class="nested-categories__show-parent"
    [mmTestTarget]="'nested-category-link'">
    {{ childCategory?.name }}
  </a>
  <ng-container
    *ngFor="let children of childCategory?.children | slice:0:categoryExpandMap[childCategory?.id];
    let i = index;">
    <a [routerLink]="[categoryRoute, children?.slug]"
      [queryParams]="queryParametersBuilder(children?.id, childCategory?.id)"
      (click)="onNestedCategoryClick(children?.name, children?.id,
      '', parentCategory?.name +'/'+ childCategory?.name)"
      class="nested-categories__item" [mmTestTarget]="'nested-category-link'">
      {{ children?.name }}
    </a>

  </ng-container>
  <button *ngIf="childCategory?.children?.length > limitOption;" class="truncation-button"
    (click)="toggleExpand(childCategory?.id)">
    {{
    categoryExpandMap[childCategory?.id] > limitOption
    ? ('SHARED.SHOW_LESS.LABEL' | translate)
    : ('CATALOG.DETAILS_PAGE.ADDITIONAL_INFO_PANEL.SHOW_MORE_CAT' | translate: {
    count: (childCategory.children.length - (limitOption - NUMBER_1))
    })
    }}
  </button>

</div>
